// @flow

export function intersect<T>(a: ImmutableArray<T>, b: ImmutableArray<T>): ImmutableArray<T> {
  return a.filter(item => b.includes(item));
}
